import Dynamic from './index-dumb';

export default Dynamic;
